export const INVOICE_ACTION = {
  ADD_INVOICE: 'add_invoice',
  REPLACE_INVOICE: 'replace_invoice',
  ADJUST_INVOICE: 'adjust_invoice',
  ADJUST_INCREASE_INVOICE: 'adjust_increase_invoice',
  ADJUST_DECREASE_INVOICE: 'adjust_decrease_invoice',
  ADJUST_INVOICE_INFORMATION: 'adjust_invoice_information',
  ADJUST_INVOICE_VALUE: 'adjust_invoice_value',
  CHANGE_INVOICE: 'change_invoice',
  PREVIEW_TEMP_EINVOICE: 'preview_temp_einvoice'
}